"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getXCLEARCorrelationInfo = exports.getSessionId = void 0;
const uuid_1 = require("uuid");
let sessionId = null;
exports.getSessionId = () => {
    if (!sessionId)
        return (sessionId = uuid_1.v4());
    return sessionId;
};
exports.getXCLEARCorrelationInfo = () => {
    return `[sessionId='${exports.getSessionId()}'], [requestId=''], [clientId=''], [deviceId='']`;
};
//# sourceMappingURL=get-xclear-correlation-info.js.map